export default "__VITE_ASSET__icA0LONv__"